import React from "react";
import { registerOverlay } from "../overlays";
import { useLang } from "../i18n";
import { emphasise, emphasiseFirstWord } from "../emphasis";

// Act 04. Two beats: the three-line promise, then what it costs. The promise
// is set at headline scale and stacked one line per row — the repetition of
// "No" is the whole effect, so it needs the vertical rhythm to land.
export default function PromiseOverlay() {
  const { t } = useLang();
  const pr = t.promise;

  return (
    <>
      <div
        ref={(el) => registerOverlay("promise-title", el)}
        className="fixed z-10 top-[13vh] left-0 right-0 text-center"
        style={{ willChange: "opacity, transform", opacity: 0 }}
      >
        <p className="ff-mono text-xs uppercase tracking-[0.2em]" style={{ color: "var(--bb-red)" }}>
          {pr.kicker}
        </p>
      </div>

      <div
        ref={(el) => registerOverlay("promise-1", el)}
        data-testid="promise-1"
        className="fixed inset-0 z-10 flex flex-col items-center justify-center px-6 text-center"
        style={{ willChange: "opacity, transform", opacity: 0 }}
      >
        <h2
          className="ff-head text-4xl sm:text-6xl lg:text-7xl leading-[1.08] tracking-[-0.025em]"
          style={{ color: "var(--bb-ink)" }}
        >
          {pr.headline.map((line, i) => (
            <span key={i} className="block">
              {emphasise(line, pr.headlineEm && pr.headlineEm[i])}
            </span>
          ))}
        </h2>
        <p
          className="mt-7 ff-serif text-[20px] sm:text-[24px] leading-[1.45] max-w-[30ch]"
          style={{ color: "var(--bb-ink-muted)" }}
        >
          {pr.tagline}
        </p>
      </div>

      <div
        ref={(el) => registerOverlay("promise-2", el)}
        data-testid="promise-2"
        className="fixed inset-0 z-10 flex flex-col items-center justify-center px-6 text-center"
        style={{ willChange: "opacity, transform", opacity: 0 }}
      >
        <p
          className="ff-head text-3xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-[-0.02em] max-w-[18ch]"
          style={{ color: "var(--bb-ink)" }}
        >
          {emphasiseFirstWord(pr.priceLead)}
        </p>
        <p className="mt-6 ff-serif text-[20px] sm:text-[24px] leading-[1.45] max-w-[34ch]" style={{ color: "var(--bb-ink-muted)" }}>
          {pr.priceBody}
        </p>
        <p className="mt-5 ff-serif text-[17px] sm:text-[19px] leading-[1.5] max-w-[38ch]" style={{ color: "var(--bb-ink-faint)" }}>
          {pr.priceNote}
        </p>
      </div>
    </>
  );
}
